import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IWeissmanModalComponent } from 'src/app/Compliance/WeissmanModalService';

export interface PaymentApprovalResultModalParams {
    result: Core.ClientPaymentApproverBulkUpdateResultModel;
    actionLabel: string;
    isReset?: boolean;
}

@Component({
    selector: 'payment-approval-result-modal',
    templateUrl: './paymentApprovalResultModal.component.html',
    standalone: false,
})
export class PaymentApprovalResultModalComponent
    implements IWeissmanModalComponent<PaymentApprovalResultModalParams, void>
{
    constructor(private readonly bsModalRef: BsModalRef) {}

    params: PaymentApprovalResultModalParams;
    result: void;

    get successCount(): number {
        return this.params.result?.successCount ?? 0;
    }

    get failures(): Core.ClientPaymentApproverBulkUpdateFailureModel[] {
        return this.params.result?.failures ?? [];
    }

    get isReset(): boolean {
        return this.params.isReset === true;
    }

    get resetMessage(): string {
        const skippedCount = this.failures.length;
        let message = `Reset completed. ${this.successCount} payment(s) were reset.`;
        if (skippedCount > 0) {
            message += ` ${skippedCount} payment(s) were skipped because they are assigned to another approver.`;
        }
        return message;
    }

    close(): void {
        this.bsModalRef.hide();
    }
}
